export const DEXIE_CLOUD_SYNCER_ID = 'dexie-cloud-syncer';
